import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules/combineModules';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
const store: any = {
  modules,
  strict: debug,
  // plugins: debug ? [createLogger()] : []
};

export default new Vuex.Store<any>(store);
